<template>
    <div>
        <v-container class="pt-0 pb-5">
            <v-row>
                <v-col>
                    <div class="pa-2 rounded elevation-1 bg-white">
                        <v-btn color="primary-dark" @click="$router.push({ name: 'Administration' })" density="compact"
                            variant="outlined">
                            <v-icon left>mdi-arrow-left</v-icon>
                            Retour
                        </v-btn>
                        <div class="text-h5 mt-5">Création d'un lien d'inscription privilégié à usage multiple</div>
                        <MultiLienVIPCreateForm></MultiLienVIPCreateForm>
                        <div class="text-h5 mt-3 my-2">Liste des liens multi-usage générés</div>
                        <ListMultiLienVIP></ListMultiLienVIP>
                    </div>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import MultiLienVIPCreateForm from "@/components/Administration/Lien_VIP/MultiLienVIPCreateForm.vue";
import ListMultiLienVIP from "@/components/Administration/Lien_VIP/ListMultiLienVIP.vue";
export default {
    components: { MultiLienVIPCreateForm, ListMultiLienVIP },
    data() {
        return {};
    },
    computed: {},
    methods: {},
    created() {

    },
};
</script>

<style lang="scss" scoped></style>